import { render, staticRenderFns } from "./OrganisationInvoice.vue?vue&type=template&id=65923c77&"
import script from "./OrganisationInvoice.vue?vue&type=script&lang=js&"
export * from "./OrganisationInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports